import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router'

import { Observable } from 'rxjs/Observable';
import { Menu } from '../../models/Menu';
import { Subscription } from 'rxjs/Subscription';
import { MenuService } from '../../services/MenuService';
import { Admin } from '../../../admin/models/Admin';
import { AdminService } from '../../../admin/services/AdminService';
import { SessionService } from '../../../admin/services/SessionService';

@Component({
	selector: 'admin-sidebar',
	template: require('./AdminSidebarComponent.html'),
	styles: [require('./AdminSidebarComponent.sass')]
})
export class AdminSidebarComponent implements OnInit, OnDestroy {
	@Input()
	module: string;
	private sidebar: Menu[];
	private subscription: Subscription;
	private adminData: Admin;
	private loggedIn: boolean;
	private sidebarStatus: boolean;
	private show: boolean;
	message: string;
	messageType: string;

	constructor(
		private menuService: MenuService,
		private adminService: AdminService,
		protected sessionService: SessionService,
		private router: Router
	) { }

	ngOnInit() {
		this.getSession();

		// Get Sidebar menu list
		let sidebarName = this.getSidebarName(this.module);
		this.sidebar = this.menuService.getMenuList(sidebarName);

		this.subscription = this.adminService.adminDataChanged$.subscribe(admin => {
			this.onSessionChanged(admin);
		});
	}

	ngOnDestroy() {
		// Destroy the subscription for session changes
		this.subscription.unsubscribe();
	}

	/**
	 * Action that fired when the session change event is catched.
	 * Update the adminData & the menuList.
	 */
	private onSessionChanged(admin: Admin) {
		//TO DO: update menu content when session changed
		this.adminData = admin;
	}

	private getSidebarStatus() {
		if (!this.adminData) {
			return false;
		} else {
			return true;
		}
	}

	private getSidebarName(moduleName: string): string {
		let sidebarName = '';
		switch (moduleName) {
			case 'camp':
				sidebarName = 'camp-admin-sidebar';
				break;
			case 'asa':
				sidebarName = 'asa-admin-sidebar';
				break;
			case 'bus':
				sidebarName = 'bus-admin-sidebar';
				break;
			case 'holiday':
				sidebarName = 'holiday-admin-sidebar';
				break;
			case 'reen':
				sidebarName = 'reen-admin-sidebar';
				break;
			case 'conference':
				sidebarName = 'conference-admin-sidebar';
				break;
			default:
				break;
		}
		return sidebarName;
	}

	// Check user role to show/hide option
	accessible(role: string, id: string) {
		if (!role.length) {
			return true;
		}
		//check exists curId => show/hide interview.
		if (this.module == 'conference') {
			if (this.adminData.pcbsRole == 'system') {
				let curId = window.sessionStorage.getItem('curId') || '0';
				let showInterviews = (id === 'interviews') == (curId === '0');
				let hasPCBSRole = role.indexOf(this.adminData.pcbsRole) !== -1;
				return hasPCBSRole && showInterviews;
			}
			else if(this.adminData.pcbsRole == 'teacher') {
				return role.indexOf(this.adminData.pcbsRole) !== -1;;
			}
		}
		return role.indexOf(this.adminData.role) !== -1 ? true : false;
	}

	private getSession(): void {
		this.sessionService.getSession().subscribe(
			admin => {
				this.adminData = admin;
				this.sidebarStatus = this.getSidebarStatus();
			},
			error => {
				//TO DO: Handle any error if needed in the furture
				this.message = '';
				this.messageType = 'alert';
			}
		);
	}

	showLinkBackInt() {
		let sessionUser: any = this.adminService.getAdminSessionData();
		return !(window.sessionStorage.getItem('curId') && this.module == 'conference' && sessionUser.pcbsRole == 'system');

	}

	clearInterSession() {
		window.sessionStorage.removeItem('curId');
		this.router.navigate(['interviews']);
	}

}



// WEBPACK FOOTER //
// ./src/common/modules/core/components/admin-sidebar/AdminSidebarComponent.ts